<template>
  <v-container grid-list-md fluid>
    <v-layout align-center justify-space-around wrap>
      <v-flex md12>
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Credentials</v-toolbar-title>
        </v-toolbar>
      </v-flex>

      <v-flex md12>
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text color="primary" :loading="snack" :disabled="snack" @click.prevent="filterCredentials()">
              <v-icon dark left>refresh</v-icon>
              Refresh
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

       <v-flex md12>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :footer-props="{
              'items-per-page-options': [15, 50, -1]
            }"
            :items="Object.values(allImageCreds)"
            :loading="isLoading.imagecreds"
            :search="search"
            :sort-by="'lastmodified'"
            :sort-desc="true"
            item-key="imageid"
            class="elevation-1"
            dense
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.imageid">
                  <td><v-icon small>vpn_key</v-icon></td>
                  <td @click="openImageTab(item.imageid)" :style="{cursor:'pointer', color:'#00e', 'text-decoration-line':'underline'}" v-if="getImageStatus(item.imageid) == 'OK'">{{ smallId(item.imageid) }}</td>
                  <td v-else>{{ smallId(item.imageid) }}</td>
                  <td>{{ item.plantid }}</td>
                  <td><v-btn color="primary" x-small @click.prevent="displayRootPassword(item.rootpassword)" :style="{cursor:'pointer'}">Show</v-btn></td>
                  <td v-if='getImageStatus(item.imageid) == "OK"'><v-icon small color="success">done</v-icon>OK</td>
                  <td v-else><v-icon small color="error">error</v-icon>DELETED</td>
                  <td>{{ item.owner }}</td>
                  <td>{{ dateToString(item.lastmodified) }}</td>
                  <td>
                    <v-btn small text :loading="snack" :disabled="snack" @click.prevent="imagecreds = item; confirmDelete = true;">
                      <v-icon dark left>delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="showRootPassword"
      hide-overlay
      width="500"
    >
      <v-card>
        <v-card-title>Root Password</v-card-title>
        <v-card-text>
          <pre>{{ rootpassword }}</pre>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showRootPassword = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmDelete"
      width="500"
      v-if="imagecreds"
    >
      <v-card>
        <v-card-title>Delete selected credentials?</v-card-title>
        <v-card-text>
          "{{ imagecreds.imageid }}" will be deleted. You can't undo this action.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.prevent="confirmDelete = false">Cancel</v-btn>
          <v-btn color="primary" text @click.prevent="calldeleteCredentials(); confirmDelete = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      persistent
      width="500"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTimeout"
      :top="true"
    >
      {{ snackMessage }}
      <v-btn
        text
        @click="snack = false"
      >
        <div class="v-menu__content--active" style="display:none; z-index:1000;"></div>
        Close
      </v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import libvue from '@/lib/vue.js'

export default {
  mixins: [libvue],
  data () {
    return {
      search: null,
      showRootPassword: false,
      rootpassword: null,
      imagecreds: null,
      confirmDelete: false,
      dialog: false,
      snack: false,
      snackColor: 'primary',
      snackMessage: '',
      snackTimeout: 1000,
      headers: [
        { text: '', value: '' },
        { text: 'ID', value: 'imageid' },
        { text: 'Plant ID', value: 'plantid' },
        { text: 'Root Password', value: 'rootpassword' },
        { text: 'Image Status', value: '' },
        { text: 'Owner', value: 'owner' },
        { text: 'Last Modified', value: 'lastmodified' },
        { text: '', value: '' },
      ]
    }
  },
  computed: {
    ...mapGetters(['allImageCreds', 'allImages', 'isLoading']),
  },
  created() {
    this.filterCredentials();
  },
  watch: {
  },
  methods: {
    openImageTab(imageid) {
      this.$router.push({ name: 'image-details', params: { ImageID: imageid } });
    },
    displayRootPassword(rootpassword) {
      this.rootpassword = rootpassword;
      this.showRootPassword = true;
    },
    getImageStatus(imageid) {
      if (!this.allImages) return;
      if (this.allImages[imageid]) {
        return "OK";
      }
    },
    calldeleteCredentials() {
      this.dialog = true;
      var t = Object.assign({}, this.imagecreds);
      this.deleteCredentials(t).then(() => {
        this.filterCredentials().then(() => {
          this.dialog = false;
          this.snack = true;
          this.snackColor = 'success';
          this.snackMessage = "Image credentials deleted";
          this.snackTimeout = 1000;
        });
      }).catch(() => {
        this.dialog = false;
      });
    },
    ...mapActions(['filterCredentials', 'deleteCredentials'])
  }
}
</script>
